import { Embroidery, StateObj } from 'src/types'
import { notThumbEmbroideryLeftThrow, thumbEmbroideryDrawerLeftThrow } from 'src/util/canvas'

export const fingerEmbroideryDrawerLeftThrow = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], backStyle: StateObj): void => {
  // 親指への刺繍
  const isEmbroideryOfThumb = embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb)
    thumbEmbroideryDrawerLeftThrow(
      ctx,
      embroideries.filter((embroidery) => embroidery.position.value === 'thumbFinger'),
      backStyle
    )

  // 小指への刺繍
  const isEmbroideryOfChild = embroideries.some((x) => x.position.value === 'childFinger')
  if (isEmbroideryOfChild) {
    notThumbEmbroideryLeftThrow(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'childFinger'),
      -90,
      20,
      -5
    )
  }
}
